/**
 * @generated SignedSource<<c8f64b1d2e4501cccca434e8038586a4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OptionsMenu_viewer$data = {
  readonly account: {
    readonly allowBotlessRecording: boolean;
  };
  readonly " $fragmentSpreads": FragmentRefs<"StreamAutoRecordAutomationConfig_useAutoRecordReason_viewer">;
  readonly " $fragmentType": "OptionsMenu_viewer";
};
export type OptionsMenu_viewer$key = {
  readonly " $data"?: OptionsMenu_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"OptionsMenu_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OptionsMenu_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StreamAutoRecordAutomationConfig_useAutoRecordReason_viewer"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowBotlessRecording",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "f9e1a700d92355d7e12e59a4793b862c";

export default node;
